'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _omit2 = require('lodash/omit');

var _omit3 = _interopRequireDefault(_omit2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _API_PATHS, _class, _desc, _value, _class2, _descriptor, _descriptor2;

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _mobx = require('mobx');

var _AppConstants = require('../constants/AppConstants');

var _AppConstants2 = _interopRequireDefault(_AppConstants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var APPLICATION_MODELS = _AppConstants2.default.APPLICATION_MODELS;


var API_PATHS = (_API_PATHS = {}, _defineProperty(_API_PATHS, APPLICATION_MODELS.LEGAL_FUNDING.model, '/legal-funding-applications/'), _defineProperty(_API_PATHS, APPLICATION_MODELS.MEDICAL.model, '/medical-funding-applications/'), _API_PATHS);

var ApplicationStore = (0, _classAutobindDecorator2.default)(_class = (_class2 = function () {
  function ApplicationStore(flatStore, caseStore, transport) {
    _classCallCheck(this, ApplicationStore);

    _initDefineProp(this, 'isLoading', _descriptor, this);

    _initDefineProp(this, 'applications', _descriptor2, this);

    this.flatStore = flatStore;
    this.caseStore = caseStore;
    this.transport = transport;
  }

  _createClass(ApplicationStore, [{
    key: 'retrieve',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(applicationId, type) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.transport.get(API_PATHS[type] + ':applicationId', { urlParams: { applicationId: applicationId } });

              case 2:
                return _context.abrupt('return', _context.sent);

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function retrieve(_x, _x2) {
        return _ref.apply(this, arguments);
      }

      return retrieve;
    }()
  }, {
    key: 'update',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref3) {
        var application = _ref3.application,
            data = _ref3.data,
            type = _ref3.type,
            _ref3$load = _ref3.load,
            load = _ref3$load === undefined ? true : _ref3$load;
        var patchData, response;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.isLoading = load;
                patchData = (0, _mobx.toJS)(data);
                _context2.next = 4;
                return this.transport.patch(API_PATHS[type] + ':applicationId/', {
                  data: patchData,
                  urlParams: { applicationId: application.id }
                });

              case 4:
                response = _context2.sent;


                Object.assign(application, response);
                this.caseStore.fetchTabCounts(application.case);
                this.isLoading = false;

              case 8:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function update(_x3) {
        return _ref2.apply(this, arguments);
      }

      return update;
    }()
  }, {
    key: 'create',
    value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(_ref5) {
        var caseId = _ref5.caseId,
            data = _ref5.data;
        var newApplication;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                data.case = caseId;
                _context3.next = 3;
                return this.transport.post(API_PATHS[APPLICATION_MODELS.LEGAL_FUNDING.model], { data: data });

              case 3:
                newApplication = _context3.sent;

                this.applications.set(newApplication.id, newApplication);
                this.flatStore.case.get(caseId).applications.unshift(newApplication);
                this.caseStore.fetchTabCounts(caseId);

              case 7:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function create(_x4) {
        return _ref4.apply(this, arguments);
      }

      return create;
    }()
  }, {
    key: 'createMedical',
    value: function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(data) {
        var newApplication, newLien;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                this.isLoading = true;
                _context4.next = 3;
                return this.transport.post(API_PATHS[APPLICATION_MODELS.MEDICAL.model], { data: data });

              case 3:
                newApplication = _context4.sent;

                this.applications.set(newApplication.id, newApplication);
                this.flatStore.case.get(data.case).applications.unshift(newApplication);

                newLien = _extends({}, newApplication.lien, { type: 'liens.medicallien' });

                newLien.application = newApplication.id;
                this.flatStore.lien.store(newLien);
                this.flatStore.case.get(data.case).liens.unshift(newLien.id);

                this.isLoading = false;

              case 11:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function createMedical(_x5) {
        return _ref6.apply(this, arguments);
      }

      return createMedical;
    }()
  }, {
    key: 'delete',
    value: function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(application) {
        var id, type, _case;

        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                id = application.id, type = application.type, _case = this.flatStore.case.get(application.case);
                _context5.next = 3;
                return this.transport.delete(API_PATHS[type] + ':id/', { urlParams: { id: id } });

              case 3:

                _case.applications = _case.applications.filter(function (application) {
                  return application.id !== id;
                });
                this.applications.delete(id);
                this.caseStore.fetchTabCounts(application.case);

              case 6:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function _delete(_x6) {
        return _ref7.apply(this, arguments);
      }

      return _delete;
    }()
  }, {
    key: 'list',
    value: function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(_ref9) {
        var _this = this;

        var caseId = _ref9.caseId;
        var params, applications;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                this.isLoading = true;
                params = { case: caseId, page_size: 'off' };
                _context6.next = 4;
                return this.transport.get('/applications/', { params: params });

              case 4:
                applications = _context6.sent;


                this.flatStore.case.get(caseId).applications = applications;
                applications.forEach(function (application) {
                  _this.applications.set(application.id, application);
                });
                this.isLoading = false;

              case 8:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function list(_x7) {
        return _ref8.apply(this, arguments);
      }

      return list;
    }()
  }, {
    key: 'fetchOpen',
    value: function () {
      var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(params, type) {
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.transport.get(API_PATHS[type] + 'open/', { params: params });

              case 2:
                return _context7.abrupt('return', _context7.sent);

              case 3:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function fetchOpen(_x8, _x9) {
        return _ref10.apply(this, arguments);
      }

      return fetchOpen;
    }()
  }, {
    key: 'fetchOpenCounts',
    value: function () {
      var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(argParams, type) {
        var params;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                params = (0, _omit3.default)(argParams, ['ordering']);
                _context8.next = 3;
                return this.transport.get(API_PATHS[type] + 'open/counts/', { params: params });

              case 3:
                return _context8.abrupt('return', _context8.sent);

              case 4:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function fetchOpenCounts(_x10, _x11) {
        return _ref11.apply(this, arguments);
      }

      return fetchOpenCounts;
    }()
  }, {
    key: 'fetchRejected',
    value: function () {
      var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(params) {
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return this.transport.get('/applications/rejected/', { params: params });

              case 2:
                return _context9.abrupt('return', _context9.sent);

              case 3:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function fetchRejected(_x12) {
        return _ref12.apply(this, arguments);
      }

      return fetchRejected;
    }()
  }, {
    key: 'fetchRejectedCounts',
    value: function () {
      var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(argParams) {
        var params;
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                params = (0, _omit3.default)(argParams, ['reason', 'ordering']);
                _context10.next = 3;
                return this.transport.get('/applications/rejected/count/', { params: params });

              case 3:
                return _context10.abrupt('return', _context10.sent);

              case 4:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function fetchRejectedCounts(_x13) {
        return _ref13.apply(this, arguments);
      }

      return fetchRejectedCounts;
    }()
  }, {
    key: 'searchFacets',
    value: function () {
      var _ref14 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(type, params) {
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return this.transport.get(API_PATHS[type] + 'open/search/', { params: params });

              case 2:
                return _context11.abrupt('return', _context11.sent);

              case 3:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function searchFacets(_x14, _x15) {
        return _ref14.apply(this, arguments);
      }

      return searchFacets;
    }()
  }, {
    key: 'loadMore',
    value: function () {
      var _ref15 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(nextPageURL) {
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return this.transport.get(nextPageURL);

              case 2:
                return _context12.abrupt('return', _context12.sent);

              case 3:
              case 'end':
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function loadMore(_x16) {
        return _ref15.apply(this, arguments);
      }

      return loadMore;
    }()
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return ApplicationStore;
}(), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'isLoading', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'applications', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return _mobx.observable.map({});
  }
}), _applyDecoratedDescriptor(_class2.prototype, 'retrieve', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'retrieve'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'update', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'update'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'create', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'create'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'createMedical', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'createMedical'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'delete', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'delete'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'list', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'list'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'fetchOpen', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'fetchOpen'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'fetchOpenCounts', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'fetchOpenCounts'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'fetchRejected', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'fetchRejected'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'fetchRejectedCounts', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'fetchRejectedCounts'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'searchFacets', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'searchFacets'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'loadMore', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'loadMore'), _class2.prototype)), _class2)) || _class;

var _default = ApplicationStore;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(APPLICATION_MODELS, 'APPLICATION_MODELS', '/app/src/stores/ApplicationStore.js');
  reactHotLoader.register(API_PATHS, 'API_PATHS', '/app/src/stores/ApplicationStore.js');
  reactHotLoader.register(ApplicationStore, 'ApplicationStore', '/app/src/stores/ApplicationStore.js');
  reactHotLoader.register(_default, 'default', '/app/src/stores/ApplicationStore.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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